// extracted by mini-css-extract-plugin
export default {"popup_wrap":"style_popup_wrap__GUur4","sub_title":"style_sub_title__NsvC4","stu_wrap":"style_stu_wrap__42ixl","stu_item":"style_stu_item__rDeM1"};